<div class="d-flex flex-column mt-2 align-items-center">
	<label class="text-center text-tertiary fw-semibold my-3 w-100">
		Interpolação de desvio {{ unidade }} - {{ periodoTitulo }}
	</label>
	<div
		*ngIf="carregando; else mapas"
		class="d-flex justify-content-center align-items-center w-100 h-50"
		style="min-height: 500px">
		<seira-loading [pageCentered]="false"></seira-loading>
	</div>
	<ng-template #mapas>
		<div
			id="desvio-interpolacao"
			style="position: relative"
			class="w-100"
			*ngIf="interpolacaoDesvio">
			<div id="mapa-legenda">
				<div class="col-12 mb-3 mb-lg-0 p-0">
					<div class="p-0 mx-1">
						<seira-mapa-interpolacao
							[mapaId]="'desvio'"
							[mapaNome]="''"
							[imageOpacity]="1"
							[colorJsonInterpolacao]="colorJsonInterpolacao"
							[interpolacao]="interpolacaoDesvio"
							[weight]="weight"
							[carregando]="carregando"
							[valores]="valoresDesvio"
							(mapaEmitter)="onMapReady($event)">
						</seira-mapa-interpolacao>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
	<seira-card-info aditionalClasses="my-2" [texto]="descricaoRelatorio" />
</div>
